const STORAGE_KEY = 'schedule.userPreferences.v1'

const readStorage = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    return raw ? JSON.parse(raw) : null
  } catch {
    return null
  }
}

const writeStorage = (value) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
  } catch {
    // ignore quota / disabled storage
  }
}

export default function userPreferencesPersist(store) {
  const saved = readStorage()
  if (saved) store.commit('userPreferences/hydrate', saved)

  store.subscribe((mutation, state) => {
    if (!mutation.type.startsWith('userPreferences/')) return
    if (mutation.type === 'userPreferences/hydrate') return
    writeStorage({
      scheduleScale: state.userPreferences.scheduleScale,
      visibleScheduleColumns: state.userPreferences.visibleScheduleColumns,
    })
  })
}

export { STORAGE_KEY }
